









import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser } from '@/lib/interfaces';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['users']),
})
export default class UserMiniRow extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  @Prop() private userId!: string;

  private get user(): IUser {
    return this.users[this.userId];
  }
}
